import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleSourceBanner"] */ "/app/src/app/_components/Article/ArticleHeader/components/GoogleSourceBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleSourceButton"] */ "/app/src/app/_components/Article/ArticleHeader/components/GoogleSourceButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/Article/ArticleHeader/components/Survey/Survey.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/Article/components/ArticleVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VodVideo"] */ "/app/src/app/_components/Article/components/VodVideo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/AbTest.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ActionableIcon"] */ "/app/src/app/_components/common/ActionableIcon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Icon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/iframe.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Image.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/app/src/app/_components/common/Logo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/SocialLinksDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BottomShare"] */ "/app/src/app/_components/EzNewswire/BottomShare.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/EzNewswire/ImageCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaidContent"] */ "/app/src/app/_components/EzNewswire/PaidContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RightRail"] */ "/app/src/app/_components/EzNewswire/RightRail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Unavailable","LoadingFallback"] */ "/app/src/app/_components/EzNewswire/unavailable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Wrapper"] */ "/app/src/app/_components/EzNewswire/Wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrinityPlayerScript"] */ "/app/src/app/_components/TrinityPlayer/TrinityPlayerScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BasicPopover"] */ "/app/src/app/_components/ui/BasicPopover.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/src/app/_components/ui/Button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/ui/ButtonV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/app/src/app/_components/ui/Tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionDescription"] */ "/app/src/app/_components/widgets/common/AccordionDescription.tsx");
